module.exports = __webpack_public_path__ + "static/TNM094_slutrapport-29d8aba31b74d0080d2886498231378d.pdf";